import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export default function tarefaService() {
	const api = useApi()

	async function getTarefas(params = {}) {
		return api.query(`${window.location.origin}${URLS.api_tarefa}`, params)
	}

	async function criarTarefa(data) {
		return api.mutation(
			`${window.location.origin}${URLS.api_tarefa}`,
			'post',
			data
		)
	}

	async function atualizarTarefa(id, data) {
		return api.mutation(
			`${window.location.origin}${URLS.api_tarefa}${id}/`,
			'put',
			data
		)
	}

	async function deletarTarefa(id) {
		return api.mutation(
			`${window.location.origin}${URLS.api_tarefa}${id}/`,
			'delete'
		)
	}

	return {
		getTarefas,
		criarTarefa,
		atualizarTarefa,
		deletarTarefa,
		...api,
	}
}
